import { IconEmailOutline } from '@iwoca/icons';
import { Pill } from '@iwoca/orion';

import styles from './FromLetterPill.module.css';

const FromLetterPill = () => (
  <Pill variant="london" size="small">
    <span className={styles.fromLetterPill}>
      <IconEmailOutline width={16} height={16} />
      From your letter
    </span>
  </Pill>
);

export default FromLetterPill;
